export default __webpack_public_path__ + "static/media/job-edit.bb077f53.png";